'use client';

import { Twitter, Linkedin, Link as LinkIcon, Share2, Check } from 'lucide-react';
import { useState } from 'react';

interface ShareButtonsProps {
  url: string;
  title: string;
}

export default function ShareButtons({ url, title }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="mt-12 pt-8 border-t border-white/10">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <span className="text-slate-400 flex items-center gap-2">
          <Share2 className="w-4 h-4" />
          Share this article
        </span>
        <div className="flex items-center gap-3">
          <a
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-lg bg-white/5 hover:bg-sky-500/20 border border-white/10 flex items-center justify-center transition-all group"
            aria-label="Share on Twitter"
          >
            <Twitter className="w-5 h-5 text-slate-400 group-hover:text-sky-400" />
          </a>
          <a
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-lg bg-white/5 hover:bg-blue-500/20 border border-white/10 flex items-center justify-center transition-all group"
            aria-label="Share on LinkedIn"
          >
            <Linkedin className="w-5 h-5 text-slate-400 group-hover:text-blue-400" />
          </a>
          <button
            onClick={handleCopyLink}
            className="w-10 h-10 rounded-lg bg-white/5 hover:bg-amber-500/20 border border-white/10 flex items-center justify-center transition-all group"
            aria-label="Copy link"
          >
            {copied ? (
              <Check className="w-5 h-5 text-green-400" />
            ) : (
              <LinkIcon className="w-5 h-5 text-slate-400 group-hover:text-amber-400" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

